import { MEDIA, MediaStats, StatProps, Text, Icon, TextVariant } from "@bridgesplit/ui";
import { formatNum } from "@bridgesplit/utils";

export function PortfolioTableStats({ stats, loading }: { stats: StatProps[]; loading: boolean }) {
    return <MediaStats variant="body1" query={MEDIA.MD} stats={stats} loading={loading} />;
}

export function RewardPoint({ points, variant }: { points: number; variant: TextVariant }) {
    return (
        <Text svgColor="secondary" variant={variant}>
            <Icon type="points" />
            {formatNum(points)}
        </Text>
    );
}
